export default __webpack_public_path__ + "static/media/max.68e90ea9.png";